import { render } from "./AnalyticMonthlyPdv.vue?vue&type=template&id=b778ab8c"
import script from "./AnalyticMonthlyPdv.vue?vue&type=script&lang=js"
export * from "./AnalyticMonthlyPdv.vue?vue&type=script&lang=js"

import "./AnalyticMonthlyPdv.scss?vue&type=style&index=0&lang=scss&external"

import exportComponent from "../../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__